export interface Accommodation {
  id: string;
  name: string;
  location: string;
  type: string;
  price: number;
  rating: number;
  reviews: number;
  image: string;
  features: string[];
  distance: string;
}

export const saudiAccommodations = [
  {
    id: 'sa-1',
    name: 'Makkah Clock Royal Tower',
    location: 'Makkah',
    type: 'Luxury Hotel',
    price: 450,
    rating: 4.9,
    reviews: 2847,
    image: 'https://public.readdy.ai/ai/img_res/3617df256c9d52f8c349c92fa011c393.jpg',
    features: ['Walking Distance to Haram', 'Family Rooms', 'Halal Dining', '24/7 Concierge'],
    distance: '50m from Masjid al-Haram'
  },
  {
    id: 'sa-2',
    name: 'Madinah Hilton Hotel',
    location: 'Madinah',
    type: 'Premium Hotel',
    price: 320,
    rating: 4.8,
    reviews: 1923,
    image: 'https://readdy.ai/api/search-image?query=elegant%20premium%20hotel%20room%20modern%20design%20comfortable%20twin%20beds%20warm%20ambient%20lighting%20spacious%20clean%20family%20friendly%20atmosphere%20prayer%20mat%20five%20star%20hotel%20interior&width=800&height=600&seq=sa-acc-002&orientation=landscape',
    features: ['Near Prophet\'s Mosque', 'Shuttle Service', 'Prayer Facilities', 'Free WiFi'],
    distance: '200m from Masjid an-Nabawi'
  },
  {
    id: 'sa-3',
    name: 'Jeddah Corniche Residence',
    location: 'Jeddah',
    type: 'Serviced Apartment',
    price: 180,
    rating: 4.7,
    reviews: 856,
    image: 'https://readdy.ai/api/search-image?query=modern%20serviced%20apartment%20living%20room%20sea%20view%20contemporary%20furniture%20open%20kitchen%20dining%20area%20bright%20natural%20light%20clean%20minimalist%20design%20family%20friendly%20comfortable%20space%20coastal%20city&width=800&height=600&seq=sa-acc-003&orientation=landscape',
    features: ['Sea View', 'Full Kitchen', 'Family Suites', 'Beach Access'],
    distance: 'Corniche Waterfront'
  },
  {
    id: 'sa-4',
    name: 'Riyadh Boulevard Suites',
    location: 'Riyadh',
    type: 'Modern Hotel',
    price: 220,
    rating: 4.6,
    reviews: 1247,
    image: 'https://readdy.ai/api/search-image?query=contemporary%20hotel%20suite%20modern%20arabian%20decor%20spacious%20bedroom%20work%20desk%20city%20skyline%20view%20warm%20lighting%20luxurious%20amenities%20clean%20professional%20atmosphere%20business%20hotel&width=800&height=600&seq=sa-acc-004&orientation=landscape',
    features: ['City Center', 'Business Facilities', 'Gym & Pool', 'Restaurant'],
    distance: 'Boulevard Riyadh City'
  },
  {
    id: 'sa-5',
    name: 'AlUla Heritage Resort',
    location: 'AlUla',
    type: 'Heritage Stay',
    price: 380,
    rating: 4.9,
    reviews: 634,
    image: 'https://readdy.ai/api/search-image?query=traditional%20arabian%20heritage%20resort%20room%20authentic%20desert%20architecture%20warm%20earth%20tones%20traditional%20textiles%20modern%20comfort%20natural%20stone%20walls%20ambient%20lighting%20cultural%20atmosphere%20desert%20resort&width=800&height=600&seq=sa-acc-005&orientation=landscape',
    features: ['Desert Views', 'Cultural Tours', 'Traditional Dining', 'Stargazing'],
    distance: 'Near Hegra Archaeological Site'
  },
  {
    id: 'sa-6',
    name: 'Taif Mountain Villa',
    location: 'Taif',
    type: 'Private Villa',
    price: 290,
    rating: 4.8,
    reviews: 412,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20mountain%20villa%20interior%20panoramic%20windows%20mountain%20views%20spacious%20living%20area%20modern%20arabian%20design%20comfortable%20seating%20warm%20natural%20lighting%20family%20friendly%20peaceful%20atmosphere%20private%20villa&width=800&height=600&seq=sa-acc-006&orientation=landscape',
    features: ['Mountain Views', 'Private Garden', 'BBQ Area', 'Cool Climate'],
    distance: 'Taif Mountains'
  }
];

export const turkeyAccommodations = [
  {
    id: 'tr-1',
    name: 'Istanbul Sultanahmet Palace',
    location: 'Istanbul',
    type: 'Boutique Hotel',
    price: 195,
    rating: 4.8,
    reviews: 2134,
    image: 'https://readdy.ai/api/search-image?query=elegant%20boutique%20hotel%20room%20istanbul%20ottoman%20inspired%20decor%20ornate%20details%20comfortable%20bed%20traditional%20turkish%20carpets%20warm%20ambient%20lighting%20historic%20charm%20modern%20comfort%20bosphorus%20view&width=800&height=600&seq=tr-acc-001&orientation=landscape',
    features: ['Historic District', 'Rooftop Terrace', 'Turkish Breakfast', 'Mosque Views'],
    distance: 'Walking distance to Blue Mosque'
  },
  {
    id: 'tr-2',
    name: 'Cappadocia Cave Suites',
    location: 'Cappadocia',
    type: 'Cave Hotel',
    price: 240,
    rating: 4.9,
    reviews: 1876,
    image: 'https://readdy.ai/api/search-image?query=unique%20cave%20hotel%20suite%20natural%20stone%20walls%20carved%20architecture%20modern%20luxury%20amenities%20warm%20lighting%20comfortable%20bed%20traditional%20turkish%20textiles%20romantic%20atmosphere%20cappadocia&width=800&height=600&seq=tr-acc-002&orientation=landscape',
    features: ['Cave Architecture', 'Balloon Views', 'Spa Services', 'Local Tours'],
    distance: 'Göreme Valley'
  },
  {
    id: 'tr-3',
    name: 'Antalya Beach Resort',
    location: 'Antalya',
    type: 'Beach Resort',
    price: 280,
    rating: 4.7,
    reviews: 3421,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20beach%20resort%20room%20mediterranean%20sea%20view%20balcony%20modern%20coastal%20design%20bright%20airy%20space%20comfortable%20furnishings%20turquoise%20accents%20relaxing%20vacation%20atmosphere%20antalya%20turkey&width=800&height=600&seq=tr-acc-003&orientation=landscape',
    features: ['Private Beach', 'All-Inclusive', 'Water Sports', 'Kids Club'],
    distance: 'Mediterranean Coast'
  },
  {
    id: 'tr-4',
    name: 'Bursa Thermal Hotel',
    location: 'Bursa',
    type: 'Spa Hotel',
    price: 165,
    rating: 4.6,
    reviews: 987,
    image: 'https://readdy.ai/api/search-image?query=relaxing%20thermal%20spa%20hotel%20room%20natural%20hot%20spring%20access%20modern%20wellness%20design%20comfortable%20bed%20calming%20earth%20tones%20spa%20amenities%20peaceful%20healing%20atmosphere%20mountain%20view%20hotel&width=800&height=600&seq=tr-acc-004&orientation=landscape',
    features: ['Thermal Springs', 'Spa Treatments', 'Mountain Views', 'Ottoman Heritage'],
    distance: 'Uludağ Mountain Area'
  },
  {
    id: 'tr-5',
    name: 'Konya Heritage House',
    location: 'Konya',
    type: 'Traditional Guesthouse',
    price: 120,
    rating: 4.8,
    reviews: 543,
    image: 'https://readdy.ai/api/search-image?query=authentic%20traditional%20turkish%20guesthouse%20room%20handcrafted%20wooden%20furniture%20traditional%20textiles%20warm%20hospitality%20cultural%20atmosphere%20comfortable%20cozy%20space%20historic%20building%20interior&width=800&height=600&seq=tr-acc-005&orientation=landscape',
    features: ['Cultural Experience', 'Home-cooked Meals', 'Rumi Museum Nearby', 'Family Run'],
    distance: 'Old City Center'
  },
  {
    id: 'tr-6',
    name: 'Bodrum Marina Apartments',
    location: 'Bodrum',
    type: 'Serviced Apartment',
    price: 210,
    rating: 4.7,
    reviews: 1256,
    image: 'https://readdy.ai/api/search-image?query=modern%20marina%20apartment%20aegean%20sea%20view%20open%20plan%20living%20contemporary%20white%20and%20blue%20decor%20balcony%20yacht%20views%20bright%20mediterranean%20style%20vacation%20atmosphere%20bodrum&width=800&height=600&seq=tr-acc-006&orientation=landscape',
    features: ['Marina Views', 'Full Kitchen', 'Pool Access', 'Nightlife Nearby'],
    distance: 'Bodrum Marina'
  }
];

export const uaeAccommodations = [
  {
    id: 'uae-1',
    name: 'Burj Khalifa Residences',
    location: 'Dubai',
    type: 'Luxury Apartment',
    price: 520,
    rating: 4.9,
    reviews: 3847,
    image: 'https://readdy.ai/api/search-image?query=ultra%20luxurious%20high%20rise%20apartment%20dubai%20floor%20to%20ceiling%20windows%20modern%20skyline%20view%20minimalist%20design%20premium%20furnishings%20marble%20finishes%20sophisticated%20elegant%20atmosphere%20downtown&width=800&height=600&seq=uae-acc-001&orientation=landscape',
    features: ['Skyline Views', 'Concierge Service', 'Pool & Gym', 'Dubai Mall Access'],
    distance: 'Downtown Dubai'
  },
  {
    id: 'uae-2',
    name: 'Palm Jumeirah Villa',
    location: 'Dubai',
    type: 'Private Villa',
    price: 680,
    rating: 4.9,
    reviews: 1923,
    image: 'https://readdy.ai/api/search-image?query=stunning%20private%20villa%20interior%20arabian%20gulf%20views%20contemporary%20luxury%20design%20spacious%20living%20area%20high%20ceilings%20premium%20furnishings%20private%20pool%20access%20exclusive%20atmosphere%20palm%20island&width=800&height=600&seq=uae-acc-002&orientation=landscape',
    features: ['Private Beach', 'Infinity Pool', 'Chef Service', 'Butler Available'],
    distance: 'Palm Jumeirah'
  },
  {
    id: 'uae-3',
    name: 'Abu Dhabi Grand Hotel',
    location: 'Abu Dhabi',
    type: 'Five-Star Hotel',
    price: 380,
    rating: 4.8,
    reviews: 2654,
    image: 'https://readdy.ai/api/search-image?query=opulent%20five%20star%20hotel%20suite%20arabian%20luxury%20design%20gold%20accents%20marble%20bathroom%20king%20bed%20city%20views%20premium%20amenities%20elegant%20sophisticated%20atmosphere%20abu%20dhabi&width=800&height=600&seq=uae-acc-003&orientation=landscape',
    features: ['Near Grand Mosque', 'Multiple Restaurants', 'Spa & Wellness', 'Business Center'],
    distance: 'Corniche Area'
  },
  {
    id: 'uae-4',
    name: 'Sharjah Family Suites',
    location: 'Sharjah',
    type: 'Family Hotel',
    price: 195,
    rating: 4.7,
    reviews: 1432,
    image: 'https://readdy.ai/api/search-image?query=spacious%20family%20suite%20separate%20bedrooms%20living%20area%20kitchenette%20comfortable%20modern%20furnishings%20warm%20welcoming%20atmosphere%20child%20friendly%20amenities%20clean%20bright%20space%20family%20hotel&width=800&height=600&seq=uae-acc-004&orientation=landscape',
    features: ['Family Rooms', 'Kids Activities', 'Cultural Museums', 'Halal Dining'],
    distance: 'Heritage Area'
  },
  {
    id: 'uae-5',
    name: 'Ras Al Khaimah Resort',
    location: 'Ras Al Khaimah',
    type: 'Beach Resort',
    price: 340,
    rating: 4.8,
    reviews: 2187,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20beach%20resort%20room%20arabian%20gulf%20views%20contemporary%20coastal%20design%20private%20balcony%20comfortable%20bed%20natural%20light%20relaxing%20vacation%20atmosphere%20ras%20al%20khaimah&width=800&height=600&seq=uae-acc-005&orientation=landscape',
    features: ['Mountain & Beach', 'Adventure Activities', 'Spa Resort', 'Golf Course'],
    distance: 'Al Marjan Island'
  },
  {
    id: 'uae-6',
    name: 'Fujairah Heritage Stay',
    location: 'Fujairah',
    type: 'Boutique Hotel',
    price: 225,
    rating: 4.6,
    reviews: 876,
    image: 'https://readdy.ai/api/search-image?query=charming%20boutique%20hotel%20room%20traditional%20emirati%20design%20elements%20modern%20comfort%20mountain%20views%20warm%20earth%20tones%20cultural%20decor%20peaceful%20authentic%20atmosphere%20fujairah%20uae&width=800&height=600&seq=uae-acc-006&orientation=landscape',
    features: ['Historic Fort Views', 'Diving Center', 'Traditional Souks', 'Mountain Hiking'],
    distance: 'Old Fujairah'
  }
];

export const moroccoAccommodations = [
  {
    id: 'ma-1',
    name: 'Riad Marrakesh Palace',
    location: 'Marrakesh',
    type: 'Luxury Riad',
    price: 210,
    rating: 4.9,
    reviews: 1876,
    image: 'https://readdy.ai/api/search-image?query=stunning%20traditional%20moroccan%20riad%20interior%20courtyard%20with%20mosaic%20tiles%20fountain%20lush%20plants%20ornate%20carved%20plasterwork%20warm%20lantern%20lighting%20elegant%20luxury%20atmosphere%20marrakesh&width=800&height=600&seq=ma-acc-001&orientation=landscape',
    features: ['Medina Location', 'Rooftop Terrace', 'Hammam Spa', 'Traditional Breakfast'],
    distance: 'Djemaa el-Fna Square'
  },
  {
    id: 'ma-2',
    name: 'Fes Medina Heritage Hotel',
    location: 'Fes',
    type: 'Heritage Hotel',
    price: 165,
    rating: 4.8,
    reviews: 1243,
    image: 'https://readdy.ai/api/search-image?query=authentic%20moroccan%20heritage%20hotel%20room%20in%20fes%20medina%20ornate%20zellige%20tilework%20carved%20cedar%20wood%20ceiling%20comfortable%20bed%20warm%20amber%20lighting%20traditional%20craftsmanship%20cultural%20atmosphere&width=800&height=600&seq=ma-acc-002&orientation=landscape',
    features: ['UNESCO Medina', 'Tannery Views', 'Cultural Tours', 'Rooftop Dining'],
    distance: 'Fes el-Bali Medina'
  },
  {
    id: 'ma-3',
    name: 'Sahara Desert Camp',
    location: 'Merzouga',
    type: 'Luxury Camp',
    price: 290,
    rating: 4.9,
    reviews: 987,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20glamping%20tent%20in%20sahara%20desert%20morocco%20with%20comfortable%20furnishings%20traditional%20berber%20textiles%20warm%20lighting%20golden%20sand%20dunes%20at%20sunset%20stargazing%20atmosphere&width=800&height=600&seq=ma-acc-003&orientation=landscape',
    features: ['Camel Trekking', 'Stargazing', 'Berber Cuisine', 'Dune Sunrise'],
    distance: 'Erg Chebbi Dunes'
  },
  {
    id: 'ma-4',
    name: 'Chefchaouen Blue Villa',
    location: 'Chefchaouen',
    type: 'Boutique Villa',
    price: 140,
    rating: 4.8,
    reviews: 765,
    image: 'https://readdy.ai/api/search-image?query=charming%20boutique%20villa%20room%20in%20chefchaouen%20blue%20city%20morocco%20whitewashed%20walls%20blue%20accents%20mountain%20views%20comfortable%20cozy%20atmosphere%20traditional%20moroccan%20decor%20peaceful&width=800&height=600&seq=ma-acc-004&orientation=landscape',
    features: ['Blue City Views', 'Mountain Hiking', 'Artisan Souks', 'Peaceful Setting'],
    distance: 'Blue Medina Center'
  },
  {
    id: 'ma-5',
    name: 'Casablanca Atlantic Hotel',
    location: 'Casablanca',
    type: 'Modern Hotel',
    price: 195,
    rating: 4.7,
    reviews: 2134,
    image: 'https://readdy.ai/api/search-image?query=modern%20elegant%20hotel%20room%20casablanca%20morocco%20atlantic%20ocean%20view%20contemporary%20design%20comfortable%20furnishings%20warm%20lighting%20business%20hotel%20sophisticated%20atmosphere&width=800&height=600&seq=ma-acc-005&orientation=landscape',
    features: ['Ocean Views', 'Business Center', 'Rooftop Pool', 'Hassan II Mosque Nearby'],
    distance: 'Corniche Ain Diab'
  },
  {
    id: 'ma-6',
    name: 'Atlas Mountain Lodge',
    location: 'Imlil',
    type: 'Mountain Lodge',
    price: 175,
    rating: 4.8,
    reviews: 543,
    image: 'https://readdy.ai/api/search-image?query=cozy%20mountain%20lodge%20room%20high%20atlas%20mountains%20morocco%20traditional%20berber%20architecture%20stone%20walls%20wooden%20beams%20panoramic%20mountain%20views%20warm%20fireplace%20peaceful%20nature%20retreat&width=800&height=600&seq=ma-acc-006&orientation=landscape',
    features: ['Toubkal Trekking', 'Mountain Views', 'Berber Culture', 'Fresh Air'],
    distance: 'High Atlas Mountains'
  }
];

export const egyptAccommodations = [
  {
    id: 'eg-1',
    name: 'Nile View Grand Hotel',
    location: 'Cairo',
    type: 'Luxury Hotel',
    price: 240,
    rating: 4.8,
    reviews: 3241,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20hotel%20room%20cairo%20egypt%20with%20panoramic%20nile%20river%20view%20elegant%20interior%20design%20comfortable%20king%20bed%20warm%20lighting%20sophisticated%20atmosphere%20five%20star%20hotel&width=800&height=600&seq=eg-acc-001&orientation=landscape',
    features: ['Nile Views', 'Pyramids Nearby', 'Rooftop Restaurant', 'Spa & Pool'],
    distance: 'Near Giza Pyramids'
  },
  {
    id: 'eg-2',
    name: 'Sharm el-Sheikh Beach Resort',
    location: 'Sharm el-Sheikh',
    type: 'Beach Resort',
    price: 310,
    rating: 4.9,
    reviews: 4512,
    image: 'https://readdy.ai/api/search-image?query=stunning%20beach%20resort%20room%20sharm%20el%20sheikh%20red%20sea%20view%20private%20balcony%20turquoise%20water%20modern%20coastal%20design%20comfortable%20luxury%20vacation%20atmosphere%20egypt&width=800&height=600&seq=eg-acc-002&orientation=landscape',
    features: ['Private Beach', 'Coral Reef Diving', 'All-Inclusive', 'Water Sports'],
    distance: 'Naama Bay'
  },
  {
    id: 'eg-3',
    name: 'Luxor Heritage Palace',
    location: 'Luxor',
    type: 'Heritage Hotel',
    price: 185,
    rating: 4.8,
    reviews: 1876,
    image: 'https://readdy.ai/api/search-image?query=elegant%20heritage%20hotel%20room%20luxor%20egypt%20nile%20river%20view%20pharaonic%20inspired%20decor%20warm%20earth%20tones%20comfortable%20bed%20ancient%20egypt%20motifs%20sophisticated%20cultural%20atmosphere&width=800&height=600&seq=eg-acc-003&orientation=landscape',
    features: ['Nile Cruises', 'Valley of Kings', 'Temple Tours', 'Rooftop Terrace'],
    distance: 'Luxor Temple Area'
  },
  {
    id: 'eg-4',
    name: 'Aswan Nubian Guesthouse',
    location: 'Aswan',
    type: 'Boutique Guesthouse',
    price: 130,
    rating: 4.7,
    reviews: 876,
    image: 'https://readdy.ai/api/search-image?query=charming%20nubian%20guesthouse%20room%20aswan%20egypt%20colorful%20traditional%20nubian%20decor%20nile%20view%20comfortable%20authentic%20cultural%20atmosphere%20warm%20vibrant%20colors%20peaceful%20riverside&width=800&height=600&seq=eg-acc-004&orientation=landscape',
    features: ['Nubian Culture', 'Nile Felucca', 'Abu Simbel Tours', 'Sunset Views'],
    distance: 'Elephantine Island Area'
  },
  {
    id: 'eg-5',
    name: 'Hurghada Marina Suites',
    location: 'Hurghada',
    type: 'Serviced Apartment',
    price: 175,
    rating: 4.6,
    reviews: 2187,
    image: 'https://readdy.ai/api/search-image?query=modern%20marina%20apartment%20hurghada%20egypt%20red%20sea%20view%20open%20plan%20living%20contemporary%20design%20balcony%20yacht%20views%20bright%20comfortable%20vacation%20atmosphere&width=800&height=600&seq=eg-acc-005&orientation=landscape',
    features: ['Marina Views', 'Snorkelling', 'Full Kitchen', 'Beach Club Access'],
    distance: 'Hurghada Marina'
  },
  {
    id: 'eg-6',
    name: 'Alexandria Mediterranean Hotel',
    location: 'Alexandria',
    type: 'Classic Hotel',
    price: 155,
    rating: 4.7,
    reviews: 1432,
    image: 'https://readdy.ai/api/search-image?query=classic%20elegant%20hotel%20room%20alexandria%20egypt%20mediterranean%20sea%20view%20colonial%20architecture%20comfortable%20furnishings%20warm%20lighting%20historic%20atmosphere%20corniche%20waterfront&width=800&height=600&seq=eg-acc-006&orientation=landscape',
    features: ['Sea Views', 'Historic Sites', 'Seafood Dining', 'Corniche Walk'],
    distance: 'Alexandria Corniche'
  }
];

export const jordanAccommodations = [
  {
    id: 'jo-1',
    name: 'Petra Wadi Rum Lodge',
    location: 'Petra',
    type: 'Heritage Lodge',
    price: 220,
    rating: 4.9,
    reviews: 2134,
    image: 'https://readdy.ai/api/search-image?query=elegant%20heritage%20lodge%20room%20near%20petra%20jordan%20rose%20red%20sandstone%20views%20comfortable%20modern%20design%20warm%20earth%20tones%20traditional%20jordanian%20textiles%20peaceful%20desert%20atmosphere&width=800&height=600&seq=jo-acc-001&orientation=landscape',
    features: ['Petra Access', 'Guided Tours', 'Traditional Cuisine', 'Desert Views'],
    distance: 'Walking distance to Petra'
  },
  {
    id: 'jo-2',
    name: 'Amman Grand Hotel',
    location: 'Amman',
    type: 'Five-Star Hotel',
    price: 265,
    rating: 4.8,
    reviews: 3456,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20five%20star%20hotel%20room%20amman%20jordan%20modern%20arabian%20design%20city%20views%20comfortable%20king%20bed%20warm%20lighting%20sophisticated%20atmosphere%20business%20hotel%20premium%20amenities&width=800&height=600&seq=jo-acc-002&orientation=landscape',
    features: ['City Center', 'Rooftop Pool', 'Spa & Wellness', 'Fine Dining'],
    distance: 'Downtown Amman'
  },
  {
    id: 'jo-3',
    name: 'Wadi Rum Desert Camp',
    location: 'Wadi Rum',
    type: 'Luxury Desert Camp',
    price: 310,
    rating: 4.9,
    reviews: 1654,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20desert%20camp%20tent%20wadi%20rum%20jordan%20martian%20landscape%20red%20sandstone%20mountains%20comfortable%20glamping%20interior%20traditional%20bedouin%20textiles%20stargazing%20atmosphere%20magical&width=800&height=600&seq=jo-acc-003&orientation=landscape',
    features: ['Jeep Tours', 'Stargazing', 'Bedouin Cuisine', 'Rock Climbing'],
    distance: 'Wadi Rum Protected Area'
  },
  {
    id: 'jo-4',
    name: 'Dead Sea Spa Resort',
    location: 'Dead Sea',
    type: 'Spa Resort',
    price: 380,
    rating: 4.9,
    reviews: 2987,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20dead%20sea%20resort%20room%20jordan%20with%20private%20balcony%20sea%20view%20mineral%20spa%20pool%20modern%20design%20comfortable%20elegant%20atmosphere%20wellness%20retreat%20lowest%20point%20earth&width=800&height=600&seq=jo-acc-004&orientation=landscape',
    features: ['Dead Sea Float', 'Mineral Spa', 'Mud Treatments', 'Infinity Pool'],
    distance: 'Dead Sea Shore'
  },
  {
    id: 'jo-5',
    name: 'Aqaba Red Sea Hotel',
    location: 'Aqaba',
    type: 'Beach Hotel',
    price: 195,
    rating: 4.7,
    reviews: 1876,
    image: 'https://readdy.ai/api/search-image?query=modern%20beach%20hotel%20room%20aqaba%20jordan%20red%20sea%20view%20comfortable%20coastal%20design%20balcony%20turquoise%20water%20bright%20sunny%20atmosphere%20diving%20snorkelling%20destination&width=800&height=600&seq=jo-acc-005&orientation=landscape',
    features: ['Red Sea Diving', 'Private Beach', 'Water Sports', 'Coral Reefs'],
    distance: 'Aqaba Beach'
  },
  {
    id: 'jo-6',
    name: 'Jerash Heritage Guesthouse',
    location: 'Jerash',
    type: 'Boutique Guesthouse',
    price: 145,
    rating: 4.7,
    reviews: 654,
    image: 'https://readdy.ai/api/search-image?query=charming%20boutique%20guesthouse%20room%20jerash%20jordan%20roman%20ruins%20views%20traditional%20stone%20architecture%20comfortable%20cozy%20atmosphere%20warm%20hospitality%20cultural%20heritage%20authentic%20experience&width=800&height=600&seq=jo-acc-006&orientation=landscape',
    features: ['Roman Ruins Access', 'Cultural Tours', 'Home Cooking', 'Peaceful Setting'],
    distance: 'Jerash Archaeological Site'
  }
];

export const accommodations: Record<string, Accommodation[]> = {
  saudiArabia: saudiAccommodations,
  turkey: turkeyAccommodations,
  uae: uaeAccommodations,
  morocco: moroccoAccommodations,
  egypt: egyptAccommodations,
  jordan: jordanAccommodations,

  malaysia: [
    {
      id: 'my-1',
      name: 'Grand Hyatt Kuala Lumpur',
      location: 'Kuala Lumpur City Centre',
      type: 'Luxury Hotel',
      price: 120,
      rating: 4.7,
      reviews: 3842,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20exterior%20in%20Kuala%20Lumpur%20with%20modern%20glass%20facade%2C%20Petronas%20Towers%20nearby%2C%20evening%20lights%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20five-star%20atmosphere&width=800&height=600&seq=malaysia-acc-1&orientation=landscape',
      features: ['Halal Restaurant', 'Family Rooms', 'Kids Pool', 'Prayer Room'],
      distance: 'KLCC City Centre',
    },
    {
      id: 'my-2',
      name: 'The Datai Langkawi',
      location: 'Langkawi Island',
      type: 'Beach Resort',
      price: 280,
      rating: 4.9,
      reviews: 2156,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20beach%20resort%20in%20Langkawi%20with%20tropical%20rainforest%2C%20infinity%20pool%2C%20ocean%20view%2C%20sunset%20lighting%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20paradise%20setting&width=800&height=600&seq=malaysia-acc-2&orientation=landscape',
      features: ['Halal Dining', 'Beach Access', 'Spa', 'Kids Club'],
      distance: 'Langkawi Rainforest',
    },
    {
      id: 'my-3',
      name: 'Eastern & Oriental Hotel',
      location: 'George Town, Penang',
      type: 'Heritage Hotel',
      price: 95,
      rating: 4.6,
      reviews: 1987,
      image: 'https://readdy.ai/api/search-image?query=Colonial%20heritage%20hotel%20in%20Penang%20with%20white%20facade%2C%20elegant%20architecture%2C%20tropical%20gardens%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20historic%20charm&width=800&height=600&seq=malaysia-acc-3&orientation=landscape',
      features: ['Halal Food', 'Heritage Building', 'Pool', 'Family Suites'],
      distance: 'George Town Heritage Zone',
    },
    {
      id: 'my-4',
      name: 'Shangri-La Rasa Sayang',
      location: 'Batu Ferringhi Beach, Penang',
      type: 'Beach Resort',
      price: 145,
      rating: 4.8,
      reviews: 2634,
      image: 'https://readdy.ai/api/search-image?query=Beachfront%20resort%20in%20Penang%20with%20palm%20trees%2C%20white%20sand%20beach%2C%20turquoise%20water%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20tropical%20paradise&width=800&height=600&seq=malaysia-acc-4&orientation=landscape',
      features: ['Halal Restaurant', 'Kids Club', 'Water Sports', 'Prayer Facilities'],
      distance: 'Batu Ferringhi Beach',
    },
    {
      id: 'my-5',
      name: 'Sunway Resort Hotel',
      location: 'Petaling Jaya, Selangor',
      type: 'Family Resort',
      price: 85,
      rating: 4.5,
      reviews: 4521,
      image: 'https://readdy.ai/api/search-image?query=Family%20resort%20hotel%20near%20theme%20park%20with%20colorful%20exterior%2C%20pools%2C%20entertainment%20facilities%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20fun%20atmosphere&width=800&height=600&seq=malaysia-acc-5&orientation=landscape',
      features: ['Theme Park Access', 'Halal Dining', 'Family Rooms', 'Kids Activities'],
      distance: 'Sunway Theme Park',
    },
    {
      id: 'my-6',
      name: 'The Majestic Hotel Kuala Lumpur',
      location: 'Kuala Lumpur Heritage District',
      type: 'Boutique Hotel',
      price: 110,
      rating: 4.7,
      reviews: 1876,
      image: 'https://readdy.ai/api/search-image?query=Colonial%20heritage%20hotel%20in%20Kuala%20Lumpur%20with%20elegant%20white%20facade%2C%20vintage%20architecture%2C%20tropical%20gardens%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20luxury%20atmosphere&width=800&height=600&seq=malaysia-acc-6&orientation=landscape',
      features: ['Halal Restaurant', 'Heritage Charm', 'Spa', 'Family Suites'],
      distance: 'KL Heritage District',
    },
  ],

  indonesia: [
    {
      id: 'id-1',
      name: 'Qunci Villas Hotel',
      location: 'Senggigi, Lombok',
      type: 'Boutique Villa',
      price: 95,
      rating: 4.6,
      reviews: 1543,
      image: 'https://readdy.ai/api/search-image?query=Boutique%20beach%20villa%20in%20Lombok%20with%20traditional%20Indonesian%20architecture%2C%20infinity%20pool%2C%20ocean%20view%2C%20sunset%20lighting%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20peaceful%20atmosphere&width=800&height=600&seq=indonesia-acc-1&orientation=landscape',
      features: ['Halal Food', 'Beach Access', 'Pool', 'Family Villas'],
      distance: 'Senggigi Beach',
    },
    {
      id: 'id-2',
      name: 'The Oberoi Lombok',
      location: 'Medana Beach, Lombok',
      type: 'Luxury Resort',
      price: 220,
      rating: 4.9,
      reviews: 987,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20beach%20resort%20in%20Lombok%20with%20private%20pavilions%2C%20turquoise%20lagoon%2C%20tropical%20gardens%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20paradise%20setting&width=800&height=600&seq=indonesia-acc-2&orientation=landscape',
      features: ['Halal Dining', 'Private Beach', 'Spa', 'Kids Club'],
      distance: 'Medana Beach',
    },
    {
      id: 'id-3',
      name: 'Jeeva Klui Resort',
      location: 'Klui Beach, Lombok',
      type: 'Beach Resort',
      price: 75,
      rating: 4.5,
      reviews: 1234,
      image: 'https://readdy.ai/api/search-image?query=Beachfront%20resort%20in%20Lombok%20with%20traditional%20bungalows%2C%20white%20sand%20beach%2C%20palm%20trees%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20tropical%20paradise&width=800&height=600&seq=indonesia-acc-3&orientation=landscape',
      features: ['Halal Restaurant', 'Beach Access', 'Pool', 'Prayer Room'],
      distance: 'Klui Beach',
    },
    {
      id: 'id-4',
      name: 'Katamaran Hotel & Resort',
      location: 'Senggigi, Lombok',
      type: 'Modern Resort',
      price: 85,
      rating: 4.6,
      reviews: 2156,
      image: 'https://readdy.ai/api/search-image?query=Modern%20beach%20resort%20in%20Lombok%20with%20contemporary%20architecture%2C%20infinity%20pool%2C%20ocean%20view%2C%20sunset%20lighting%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20family-friendly&width=800&height=600&seq=indonesia-acc-4&orientation=landscape',
      features: ['Halal Food', 'Water Sports', 'Kids Pool', 'Family Rooms'],
      distance: 'Senggigi Beachfront',
    },
    {
      id: 'id-5',
      name: 'Sudamala Resort',
      location: 'Senggigi, Lombok',
      type: 'Boutique Resort',
      price: 105,
      rating: 4.7,
      reviews: 1678,
      image: 'https://readdy.ai/api/search-image?query=Boutique%20resort%20in%20Lombok%20with%20traditional%20Indonesian%20design%2C%20lush%20gardens%2C%20pool%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20peaceful%20atmosphere&width=800&height=600&seq=indonesia-acc-5&orientation=landscape',
      features: ['Halal Dining', 'Spa', 'Beach Access', 'Prayer Facilities'],
      distance: 'Senggigi Beach',
    },
    {
      id: 'id-6',
      name: 'Sheraton Senggigi Beach Resort',
      location: 'Senggigi, Lombok',
      type: 'Five-Star Resort',
      price: 125,
      rating: 4.6,
      reviews: 2987,
      image: 'https://readdy.ai/api/search-image?query=Large%20beachfront%20resort%20in%20Lombok%20with%20multiple%20pools%2C%20tropical%20gardens%2C%20ocean%20view%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20family-friendly&width=800&height=600&seq=indonesia-acc-6&orientation=landscape',
      features: ['Halal Restaurant', 'Kids Club', 'Water Sports', 'Family Suites'],
      distance: 'Senggigi Beachfront',
    },
  ],

  maldives: [
    {
      id: 'mv-1',
      name: 'Soneva Fushi',
      location: 'Baa Atoll',
      type: 'Luxury Resort',
      price: 650,
      rating: 4.9,
      reviews: 1234,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20overwater%20villa%20in%20Maldives%20with%20wooden%20deck%2C%20crystal%20clear%20turquoise%20lagoon%2C%20blue%20sky%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20paradise%20setting&width=800&height=600&seq=maldives-acc-1&orientation=landscape',
      features: ['Halal Certified', 'Private Pool', 'Kids Club', 'Water Sports'],
      distance: 'Baa Atoll UNESCO Reserve',
    },
    {
      id: 'mv-2',
      name: 'Anantara Dhigu Resort',
      location: 'South Male Atoll',
      type: 'Overwater Resort',
      price: 420,
      rating: 4.8,
      reviews: 2156,
      image: 'https://readdy.ai/api/search-image?query=Overwater%20bungalows%20in%20Maldives%20with%20wooden%20walkway%2C%20turquoise%20water%2C%20sunset%20lighting%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20luxury%20atmosphere&width=800&height=600&seq=maldives-acc-2&orientation=landscape',
      features: ['Halal Dining', 'Overwater Villas', 'Spa', 'Prayer Room'],
      distance: 'South Male Atoll',
    },
    {
      id: 'mv-3',
      name: 'Kurumba Maldives',
      location: 'North Male Atoll',
      type: 'Beach Resort',
      price: 380,
      rating: 4.7,
      reviews: 3421,
      image: 'https://readdy.ai/api/search-image?query=Beach%20resort%20in%20Maldives%20with%20white%20sand%2C%20palm%20trees%2C%20turquoise%20lagoon%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20family-friendly&width=800&height=600&seq=maldives-acc-3&orientation=landscape',
      features: ['Halal Food', 'Kids Club', 'Beach Villas', 'Water Sports'],
      distance: 'North Male Atoll',
    },
    {
      id: 'mv-4',
      name: 'Constance Moofushi',
      location: 'South Ari Atoll',
      type: 'All-Inclusive Resort',
      price: 480,
      rating: 4.8,
      reviews: 1876,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20beach%20villa%20in%20Maldives%20with%20private%20pool%2C%20ocean%20view%2C%20tropical%20setting%2C%20sunset%20lighting%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20paradise%20atmosphere&width=800&height=600&seq=maldives-acc-4&orientation=landscape',
      features: ['Halal Restaurant', 'All-Inclusive', 'Diving Center', 'Prayer Facilities'],
      distance: 'South Ari Atoll',
    },
    {
      id: 'mv-5',
      name: 'Adaaran Prestige Vadoo',
      location: 'South Male Atoll',
      type: 'Overwater Villa',
      price: 520,
      rating: 4.7,
      reviews: 1543,
      image: 'https://readdy.ai/api/search-image?query=Overwater%20villa%20in%20Maldives%20with%20glass%20floor%2C%20turquoise%20lagoon%2C%20marine%20life%20visible%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20luxury%20setting&width=800&height=600&seq=maldives-acc-5&orientation=landscape',
      features: ['Halal Dining', 'Overwater Villas', 'Spa', 'Snorkeling'],
      distance: 'South Male Atoll',
    },
    {
      id: 'mv-6',
      name: 'Bandos Maldives',
      location: 'North Male Atoll',
      type: 'Family Resort',
      price: 290,
      rating: 4.6,
      reviews: 4521,
      image: 'https://readdy.ai/api/search-image?query=Family%20resort%20in%20Maldives%20with%20beach%20bungalows%2C%20white%20sand%2C%20palm%20trees%2C%20turquoise%20water%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20vibrant%20colors%2C%20high%20quality%2C%20family-friendly&width=800&height=600&seq=maldives-acc-6&orientation=landscape',
      features: ['Halal Food', 'Kids Club', 'Water Sports', 'Family Rooms'],
      distance: 'North Male Atoll',
    },
  ],

  bosnia: [
    {
      id: 'ba-1',
      name: 'Hotel Europe Sarajevo',
      location: 'Sarajevo Old Town',
      type: 'Heritage Hotel',
      price: 75,
      rating: 4.6,
      reviews: 1876,
      image: 'https://readdy.ai/api/search-image?query=Historic%20hotel%20in%20Sarajevo%20with%20elegant%20facade%2C%20Ottoman%20architecture%20influence%2C%20old%20town%20setting%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20cultural%20atmosphere&width=800&height=600&seq=bosnia-acc-1&orientation=landscape',
      features: ['Halal Restaurant', 'Historic Building', 'City Center', 'Family Rooms'],
      distance: 'Bascarsija Old Town',
    },
    {
      id: 'ba-2',
      name: 'Swissotel Sarajevo',
      location: 'Sarajevo City Centre',
      type: 'Modern Hotel',
      price: 95,
      rating: 4.7,
      reviews: 2341,
      image: 'https://readdy.ai/api/search-image?query=Modern%20hotel%20in%20Sarajevo%20with%20contemporary%20glass%20facade%2C%20mountain%20views%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20luxury%20atmosphere&width=800&height=600&seq=bosnia-acc-2&orientation=landscape',
      features: ['Halal Dining', 'Spa', 'Mountain Views', 'Prayer Room'],
      distance: 'Sarajevo City Centre',
    },
    {
      id: 'ba-3',
      name: 'Hotel Mepas',
      location: 'Mostar',
      type: 'Modern Hotel',
      price: 65,
      rating: 4.5,
      reviews: 1234,
      image: 'https://readdy.ai/api/search-image?query=Modern%20hotel%20in%20Mostar%20with%20contemporary%20architecture%2C%20river%20views%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20comfortable%20atmosphere&width=800&height=600&seq=bosnia-acc-3&orientation=landscape',
      features: ['Halal Food', 'River Views', 'Pool', 'Family Suites'],
      distance: 'Mostar City Centre',
    },
    {
      id: 'ba-4',
      name: 'Hotel Pellegrino',
      location: 'Mostar Old Town',
      type: 'Boutique Hotel',
      price: 55,
      rating: 4.6,
      reviews: 987,
      image: 'https://readdy.ai/api/search-image?query=Boutique%20hotel%20in%20Mostar%20old%20town%20with%20traditional%20stone%20architecture%2C%20bridge%20views%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20historic%20charm&width=800&height=600&seq=bosnia-acc-4&orientation=landscape',
      features: ['Halal Restaurant', 'Bridge Views', 'Historic Location', 'Prayer Facilities'],
      distance: 'Stari Most Bridge',
    },
    {
      id: 'ba-5',
      name: 'Radon Plaza Hotel',
      location: 'Sarajevo',
      type: 'Business Hotel',
      price: 85,
      rating: 4.6,
      reviews: 1654,
      image: 'https://readdy.ai/api/search-image?query=Business%20hotel%20in%20Sarajevo%20with%20modern%20facade%2C%20city%20views%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20comfortable%20atmosphere&width=800&height=600&seq=bosnia-acc-5&orientation=landscape',
      features: ['Halal Dining', 'Spa', 'City Views', 'Family Rooms'],
      distance: 'Sarajevo City',
    },
    {
      id: 'ba-6',
      name: 'Hotel Hills Sarajevo',
      location: 'Ilidža, Sarajevo',
      type: 'Spa Hotel',
      price: 70,
      rating: 4.7,
      reviews: 2156,
      image: 'https://readdy.ai/api/search-image?query=Spa%20hotel%20in%20Sarajevo%20with%20elegant%20architecture%2C%20thermal%20springs%2C%20mountain%20backdrop%2C%20sunny%20day%2C%20professional%20hotel%20photography%2C%20warm%20tones%2C%20high%20quality%2C%20wellness%20atmosphere&width=800&height=600&seq=bosnia-acc-6&orientation=landscape',
      features: ['Halal Food', 'Thermal Spa', 'Nature Setting', 'Prayer Room'],
      distance: 'Ilidža Nature Park',
    },
  ],
};